import { Action, createReducer, on } from '@ngrx/store';
import { AlertItem, AlertListResponse, CounterResponse } from '../../../api/models';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { alertActions } from './alert.actions';

export interface AlertState {
  //alert list
  alertList: {
    state: ILoaderActionPayload;
    data?: AlertListResponse;
  };

  markAsResolved: {
    state: ILoaderActionPayload;
    data?: AlertItem;
  };
  markAlertsAsResolved: {
    state: ILoaderActionPayload;
    data?: CounterResponse;
  };
  loadOneAlert: {
    state: ILoaderActionPayload;
    data?: AlertItem;
  };
}

const initialState: AlertState = {
  alertList: {
    state: {
      value: LoadingState.NONE,
    },
  },
  markAsResolved: {
    state: { value: LoadingState.NONE },
  },
  markAlertsAsResolved: {
    state: { value: LoadingState.NONE },
  },
  loadOneAlert: {
    state: { value: LoadingState.NONE },
  },
};

const reducer = createReducer(
  initialState,
  // load alerts
  on(alertActions.loadAlertList, (state) => ({
    ...state,
    alertList: { state: { value: LoadingState.LOADING } },
  })),
  on(alertActions.loadAlertListDone, (state, props) => ({
    ...state,
    alertList: { state: props.state, data: props.data },
  })),
  on(alertActions.loadAlertListSetState, (state, props) => ({
    ...state,
    alertList: { state: props.state },
  })),
  // loadOne
  on(alertActions.loadOneAlert, (state) => ({
    ...state,
    loadOneAlert: { state: { value: LoadingState.LOADING } },
  })),
  on(alertActions.loadOneAlertDone, (state, props) => ({
    ...state,
    loadOneAlert: { state: props.state, data: props.data },
  })),
  //mark as resolved
  on(alertActions.markAsResolved, (state) => ({
    ...state,
    markAsResolved: { state: { value: LoadingState.LOADING } },
  })),
  on(alertActions.markAsResolvedDone, (state, props) => ({
    ...state,
    markAsResolved: { state: props.state, data: props.data },
    alertList: {
      ...state.alertList,
      data: {
        ...state.alertList.data,
        list:
          state.alertList.data?.list?.map((item) => (item.id === props.data?.id ? { ...item, ...props.data } : item)) ??
          [],
        count: state.alertList.data?.count ?? 0,
      },
    },
  })),
  on(alertActions.markAsResolvedSetState, (state, props) => ({
    ...state,
    markAsResolved: { state: props.state },
  })),
  //mark multiple as resolved (batch mode)
  on(alertActions.markAlertsAsResolved, (state) => ({
    ...state,
    markAlertsAsResolved: { state: { value: LoadingState.LOADING } },
  })),
  on(alertActions.markAlertsAsResolvedDone, (state, props) => {
    const now = new Date().toISOString();
    const body = props.request;
    return {
      ...state,
      markAlertsAsResolved: { state: props.state },
      alertList: {
        ...state.alertList,
        data: {
          ...state.alertList.data,
          list:
            state.alertList.data?.list?.map((item) => {
              if (item.resolvedOn) return item;
              // Batch mode: mark all except excluded
              if (body?.filter && body?.excludedIds) {
                return body.excludedIds.includes(item.id) ? item : { ...item, resolvedOn: now };
              }
              // Standard: mark specific IDs
              if (body?.alertIds?.includes(item.id)) {
                return { ...item, resolvedOn: now };
              }
              return item;
            }) ?? [],
          count: state.alertList.data?.count ?? 0,
        },
      },
    };
  }),
  on(alertActions.markAlertsAsResolvedSetState, (state, props) => ({
    ...state,
    markAlertsAsResolved: { state: props.state },
  })),
);

export function alertReducer(state: AlertState | undefined, action: Action) {
  return reducer(state, action);
}
